export default "__VITE_ASSET__8653c2e3__"